export default "__VITE_ASSET__fa9ba2e6__"